var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "results-order" }, [
    _c("div", { staticClass: "row" }, [
      _c(
        "div",
        {
          staticClass:
            "fake-form-field form-field--stretch form-field--style-1 form-field--no-asterisk col",
        },
        [
          _vm.showTitle
            ? _c("div", { staticClass: "filter-label" }, [
                _c("i", { staticClass: "fas fa-sort d-none d-sm-block" }),
                _vm._v(" "),
                _c("label", { staticClass: "col-form-label" }, [
                  _vm._v(
                    "\n          " +
                      _vm._s(
                        _vm.$t("messages_nl.search-form.sortFilterTitle")
                      ) +
                      "\n        "
                  ),
                ]),
              ])
            : _vm._e(),
          _vm._v(" "),
          _c(
            "select",
            {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.sortSelected,
                  expression: "sortSelected",
                },
              ],
              staticClass: "form-control results-order",
              attrs: { id: "sortBy", name: "sortBy" },
              on: {
                click: function ($event) {
                  return _vm.$emit("clicked")
                },
                change: function ($event) {
                  var $$selectedVal = Array.prototype.filter
                    .call($event.target.options, function (o) {
                      return o.selected
                    })
                    .map(function (o) {
                      var val = "_value" in o ? o._value : o.value
                      return val
                    })
                  _vm.sortSelected = $event.target.multiple
                    ? $$selectedVal
                    : $$selectedVal[0]
                },
              },
            },
            _vm._l(_vm.sortOptions, function (option, index) {
              return _c(
                "option",
                { key: index, domProps: { value: option.value } },
                [_vm._v("\n          " + _vm._s(option.name) + "\n        ")]
              )
            }),
            0
          ),
        ]
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }